export const PASSWORD_REQUIREMENTS_MESSAGE =
  "Votre mot de passe doit contenir au moins 12 caractères et trois des quatre catégories suivantes : majuscules, minuscules, chiffres, caractères spéciaux (ex : !&$_+-/*( )%=[])";
export const PASSWORD_SUCCESS_MESSAGE =
  "Votre mot de passe est conforme aux exigences de sécurité";
export const PASSWORD_VALIDATION_ERROR =
  "Le mot de passe ne respecte pas les exigences de sécurité";

export const isPasswordSecure = (password = "") => {
  const categoriesCount = [
    /[A-ZÀ-ÖØ-Þ]/.test(password),
    /[a-zà-öø-ÿ]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-zÀ-ÖØ-öø-ÿ0-9]/.test(password),
  ].filter(Boolean).length;

  return password.length >= 12 && categoriesCount >= 3;
};

export const getPasswordHelper = (password = "") => {
  const passwordIsSecure = isPasswordSecure(password);

  return {
    className: passwordIsSecure
      ? "mt-1 text-success"
      : password
        ? "mt-1 text-danger"
        : "mt-1 text-muted",
    message: passwordIsSecure
      ? PASSWORD_SUCCESS_MESSAGE
      : PASSWORD_REQUIREMENTS_MESSAGE,
  };
};
